import React from 'react';
import { List, Brain, Clock, Globe } from 'lucide-react';

const Features = ({ language }) => {
  const texts = {
    en: {
      title: 'Powerful AI Features for Smart Cooking',
      subtitle: 'Experience revolutionary technology that turns your ingredients into amazing recipes',
      features: [
        {
          icon: List,
          title: 'Photo Recognition',
          description: 'Simply take a photo of your ingredients and our AI instantly recognizes what you have available'
        },
        {
          icon: Brain,
          title: 'Smart Recipe Generation',
          description: 'Get personalized AI-generated recipes based on your exact ingredients and dietary preferences'
        },
        {
          icon: Clock,
          title: 'Instant Results',
          description: 'Receive custom recipes in seconds, optimized for your available ingredients and cooking time'
        },
        {
          icon: Globe,
          title: 'Endless Inspiration',
          description: 'Discover new cooking possibilities and cuisines from around the world tailored to your taste'
        }
      ]
    },
    pt: {
      title: 'Recursos Poderosos de IA para Culinária Inteligente',
      subtitle: 'Experimente tecnologia revolucionária que transforma seus ingredientes em receitas incríveis',
      features: [
        {
          icon: List,
          title: 'Reconhecimento de Fotos',
          description: 'Simplesmente tire uma foto dos seus ingredientes e nossa IA reconhece instantaneamente o que você tem disponível'
        },
        {
          icon: Brain,
          title: 'Geração Inteligente de Receitas',
          description: 'Obtenha receitas personalizadas geradas por IA com base nos seus ingredientes exatos e preferências alimentares'
        },
        {
          icon: Clock,
          title: 'Resultados Instantâneos',
          description: 'Receba receitas personalizadas em segundos, otimizadas para seus ingredientes disponíveis e tempo de cozimento'
        },
        {
          icon: Globe,
          title: 'Inspiração Infinita',
          description: 'Descubra novas possibilidades culinárias e cozinhas do mundo inteiro adaptadas ao seu paladar'
        }
      ]
    }
  };

  const t = texts[language];

  return (
    <section id="section-2" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            {t.title}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {t.features.map((feature, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-8 hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-16 h-16 bg-green-600 rounded-2xl flex items-center justify-center mb-6">
                <feature.icon className="w-8 h-8 text-white" />
              </div>
              
              <h3 className="text-xl font-semibold text-gray-900 mb-4">
                {feature.title}
              </h3>
              
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* AI Recipe Preview */}
        <div className="mt-16 text-center">
          <div className="relative inline-block">
            <img
              src="/images/ai-photo-scanner.jpg"
              alt={language === 'en' ? 'AI photo scanning ingredients and generating recipes' : 'IA escaneando ingredientes e gerando receitas'}
              className="w-full max-w-2xl rounded-2xl shadow-2xl"
            />
            <div className="absolute -top-4 -right-4 bg-green-600 text-white px-6 py-3 rounded-full text-lg font-semibold shadow-lg">
              {language === 'en' ? 'AI Recipes in Real-time' : 'Receitas de IA em Tempo Real'}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
